import { render } from "./ProjectTeamsSection.vue?vue&type=template&id=70f3d5ea&scoped=true&ts=true"
import script from "./ProjectTeamsSection.vue?vue&type=script&lang=ts"
export * from "./ProjectTeamsSection.vue?vue&type=script&lang=ts"

import "./ProjectTeamsSection.vue?vue&type=style&index=0&id=70f3d5ea&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70f3d5ea"]])

export default __exports__